import { createContext, useContext, useMemo, useState } from 'react'
import { useTrackingsInit } from '../../hooks/trackings/useTrackingsInit'
import { useDetectBot } from '../../hooks/useDetectBot'
import { useConfig } from '../config'

const TrackingsContext = createContext()

const TrackingsInit = ({ trackings, setTrackings }) => {
	useTrackingsInit({ trackings, setTrackings })
	return null
}

const TrackingsProvider = ({ children }) => {
	const { trackings: trackingsConfig = [], projectSpecific: { trackings: projectTrackings = [] } = {} } = useConfig()

	const { isBot, loading } = useDetectBot()

	const mergedTrackings = [...trackingsConfig, ...projectTrackings]

	const [trackings, setTrackings] = useState(
		mergedTrackings
			.filter(({ enabled }) => enabled)
			.map(({ id, code, apiUrl }) => ({
				id,
				code,
				apiUrl,
				initialized: false,
				ready: false,
				handler: null,
			}))
	)

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const memoizedTrackings = useMemo(() => trackings, [])

	return (
		<TrackingsContext.Provider value={trackings}>
			{!loading && !isBot && <TrackingsInit trackings={memoizedTrackings} setTrackings={setTrackings} />}
			{children}
		</TrackingsContext.Provider>
	)
}

export default TrackingsProvider
export const useTrackingsContext = () => useContext(TrackingsContext)
